import type { EnvironmentProviders, Provider } from '@angular/core';

// Using the real services in prod, nothing to replace.
export const fakeProviders: readonly (Provider | EnvironmentProviders)[] = [];
